<template>
  <ExpandedLayout>
    <template #content>
      <KidsAuthSection :kids_controller="kids_controller"></KidsAuthSection>
    </template>
  </ExpandedLayout>
</template>

<script setup>
import KidsController from '@/js/Settings/Kids/KidsController';
import ExpandedLayout  from '@/vue/Layouts/ExpandedLayout.vue';
import KidsAuthSection from './Sections/KidsAuthSection.vue';

const kids_controller = KidsController;
</script>